import {Component, inject, signal} from "@angular/core"
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import { Router, RouterModule } from "@angular/router"

import { Button } from "primeng/button"
import { InputText } from "primeng/inputtext"
import { Password } from "primeng/password"

import {ApiAuthService} from "@logick/core-api"

@Component({
  selector: "app-user-login-page",
  imports: [ReactiveFormsModule, RouterModule, InputText, Password, Button],
  templateUrl: "./user-login.page.html",
})
export class UserLoginPage {

  apiAuthService = inject(ApiAuthService)

  loginForm: FormGroup
  isLoading = signal<boolean>(false)

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      login: ["", [Validators.required]],
      password: ["", [Validators.required]]
    })
  }

  submitForm() {
    if (this.isLoading() || !this.loginForm.valid) {
      return
    }

    this.isLoading.set(true)
    this.apiAuthService.login(
      this.loginForm.get("login")?.value,
      this.loginForm.get("password")?.value
    ).subscribe({
      next: () => {
        this.router.navigateByUrl("").then()
      },
      error: (error) => {
        this.isLoading.set(false)
        this.loginForm.setErrors({ "invalid": true })
      }
    })

  }
}
